import React, { useState } from 'react';
import FeaturesTab1 from './FeaturesTab1';
import FeaturesTab2 from './FeaturesTab2';
import FeaturesTab3 from './FeaturesTab3';
import './App.css';

const Features = () => {
    const [activeTab, setActiveTab] = useState(1);

    const handleTabChange = (tabNumber) => {
        setActiveTab(tabNumber);
    };

    return (
        <section id='section-fs'>
            <div className='top-section'>
                <h1 style={{ fontSize: '2rem', marginBottom: '10px' }}>Features</h1>
                <p>Our aim is to make it quick and easy for you to access your favourite websites.
                    Your bookmarks sync between your devices so you can access them on the go.</p>
            </div>
            <div className="features-header">
                <div className={activeTab === 1 ? 'active-tab' : ''} onClick={() => handleTabChange(1)}>Simple Bookmarking</div>
                <div className={activeTab === 2 ? 'active-tab' : ''} onClick={() => handleTabChange(2)}>Speedy Searching</div>
                <div className={activeTab === 3 ? 'active-tab' : ''} onClick={() => handleTabChange(3)}>Easy Sharing</div>
                <div className="red-line" style={{ left: `${(activeTab - 1) * 33.33}%` }}></div>
            </div>
            <div id="info">
                {activeTab === 1 && <FeaturesTab1 />}
                {activeTab === 2 && <FeaturesTab2 />}
                {activeTab === 3 && <FeaturesTab3 />}
            </div>
        </section>
    ); 
}

export default Features;
